<template>
  <div class="page page-create-user">
    <h2>Создание нового пользователя</h2>
    <br><br>
    <div class="row">
      <div class="col col-xl-7">
        <label>Фамилия</label>
        <input type="text" class="form-control" v-model="user.last_name" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col col-xl-9">
        <label>Имя</label>
        <input type="text" class="form-control" v-model="user.first_name" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col col-xl-9">
        <label>Отчество (не обязательно)</label>
        <input type="text" class="form-control" v-model="user.middle_name" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col col-xl-9">
        <label>Логин</label>
        <input type="text" class="form-control" v-model="user.username" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col col-xl-9">
        <label>Пароль</label>
        <input type="password" class="form-control" v-model="user.password" placeholder required />
      </div>
    </div>
    <div class="row">
      <div class="col col-xl-9">
        <label>Роли</label>
        <Mselect
          v-if="accessibleRoles && user.roles"
          v-model="user.roles"
          :options="accessibleRoles"
          option-key="name"
          option-label="name"
        />
      </div>
    </div>
    <hr class="mb-4" />
    <button class="btn btn-primary" @click="createUser()">Создать</button>
  </div>
</template>
<script>
import usersAPI from '@/api/users'
import Swal from 'sweetalert2'

export default {
  name: 'CreateUser',
  data () {
    return {
      isUpdating: false,
      user: {
        first_name: '',
        middle_name: '',
        last_name: '',
        username: '',
        password: '',
        roles: []
      },
      accessibleRoles: []
    }
  },
  mounted () {
    usersAPI
      .getAccessibleRoles()
      .then(roles => {
        this.accessibleRoles = Object.values(roles)
        this.user.roles.push(roles['Пользователь'].name)
      })
  },
  methods: {
    createUser () {
      usersAPI
        .createItem(this.user)
        .then(user => {
          this.$router.push(`/users/${user.model.id}`)
        })
        .catch(text => {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>
<style scoped>
  .page-create-user .btn-primary {
    width: 8rem;
    margin-left: .4rem;
    float: right !important;
  }
  .row {
    margin-bottom: 0.5rem;
  }
</style>
